import styled from "@emotion/styled"
import tw from "twin.macro"
import { default as tailwindConfig } from "../utils/tailwindConfig"

const Container = styled.div`
  ${tw`w-full mx-auto px-4`}
  @media (min-width: ${tailwindConfig.theme.screens.sm}) {
    max-width: ${tailwindConfig.theme.screens.sm};
  }
  @media (min-width: ${tailwindConfig.theme.screens.md}) {
    max-width: ${tailwindConfig.theme.screens.md};
  }
  @media (min-width: ${tailwindConfig.theme.screens.lg}) {
  max-width: ${(props) =>
    props.width === `sm` ? `900px` : tailwindConfig.theme.screens.lg};
  }
  @media (min-width: ${tailwindConfig.theme.screens.xl}) {
  max-width: ${(props) =>
    props.width === `sm` ? `900px` : tailwindConfig.theme.screens.xl};
  }
`

export default Container
